module.exports = __webpack_public_path__ + "static/media/document.00b581b8.svg";